export const DIAL_OUT_MODE_VALUES = ['ACTION_LIST', 'TRIGGER_VARIABLE'];
export var DialOutIntent;
(function (DialOutIntent) {
    DialOutIntent["CONVERSE"] = "CONVERSE";
    DialOutIntent["NOTIFY"] = "NOTIFY";
})(DialOutIntent || (DialOutIntent = {}));
export const DIAL_OUT_INTENT_VALUES = [
    DialOutIntent.CONVERSE,
    DialOutIntent.NOTIFY,
];
export const DIAL_OUT_INTENT_DEFAULT = DialOutIntent.CONVERSE;
/** Whether dial-out configuration applies to an agent.
 *  An agent dials out only if it's outbound AND has the CALL channel. */
export function isDialOutAgent(args) {
    return args.direction === 'OUTBOUND' && (args.channels ?? []).includes('CALL');
}
//# sourceMappingURL=dial-out-settings.js.map